module.exports = __webpack_public_path__ + "images/category_lp/brand/store_images/2_618212bc9ceec3b9d996674b31d6ad0f.png";